module.exports = __webpack_public_path__ + "static/media/5.4-evals.bfa40ae4.png";